module.exports = "<div class=alerts> <div v-for=\"alert in alerts\" v-bind:class=alert.type transition=expand> <p> {{alert.message}} </p> </div> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Alerts.vue
 ** module id = 79
 ** module chunks = 0
 **/